import type { User } from '@/@types/user'
import ThreeDotsIcon from '@/assets/three-dots.svg?react'
import clsx from 'clsx'
import { map } from 'lodash-es'
import { type HTMLAttributes, useMemo } from 'react'
import Avatar from './Avatar'
import ClickWrapper from './ClickWrapper'
import styles from './ClickableStackAvatarGroup.module.css'

export interface ClickableStackAvatarGroupProps extends HTMLAttributes<HTMLDivElement> {
	data: User[]
	isMoreIconShow?: boolean
}

function UserAvatar({ user, index }: { user: User; index: number }) {
	const wrapperStyle = useMemo(
		() => ({
			left: `${index * 42 - (index === 0 ? 0 : index * 9)}px`,
		}),
		[index]
	)

	return (
		<ClickWrapper key={user.id} className={styles.avatarWrapper} style={wrapperStyle}>
			<Avatar data={user} className={styles.avatar} />
		</ClickWrapper>
	)
}

function MoreButton({ userCount }: { userCount: number }) {
	const wrapperStyle = useMemo(
		() => ({
			left: `${3 * 40 - 3 * 9}px`,
		}),
		[]
	)

	return (
		<ClickWrapper
			onClick={(e) => {
				e.stopPropagation()
			}}
			className={styles.moreButtonWrapper}
			style={wrapperStyle}
		>
			<div className={styles.moreButton}>
				<ThreeDotsIcon className={styles.moreIcon} />
			</div>
		</ClickWrapper>
	)
}

export default function ClickableStackAvatarGroup({
	data: users,
	isMoreIconShow,
	className,
	...props
}: ClickableStackAvatarGroupProps) {
	const containerStyle = useMemo(
		() => ({
			width: `${users.length * 42 - (users.length - 1) * 9}px`,
			height: '42px',
		}),
		[users.length]
	)

	return (
		<div className={clsx(styles.container, className)} style={containerStyle} {...props}>
			{map(users, (user, index) => (
				<UserAvatar key={user.id} user={user} index={index} />
			))}

			{isMoreIconShow && <MoreButton userCount={users.length} />}
		</div>
	)
}
